<template>
  <nav
    class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
  >
    <div
      class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
    >
      <!-- Toggler -->
      <button
        class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
        type="button"
        v-on:click="toggleCollapseShow('bg-white m-2 py-3 px-6')"
      >
        <i class="fas fa-bars"></i>
      </button>
      <!-- Brand -->
      <router-link
        class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
        to="/"
      >
        <img alt="Gestión APA" class="h-10 w-auto mx-auto" :src="logoSrc" />
      </router-link>
      <!-- User -->
      <ul class="md:hidden items-center flex flex-wrap list-none">
        <li class="inline-block relative">
          <user-dropdown />
        </li>
      </ul>
      <!-- Collapse -->
      <div
        class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
        v-bind:class="collapseShow"
      >
        <!-- Collapse header -->
        <div
          class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200"
        >
          <div class="flex flex-wrap">
            <div class="w-6/12">
              <router-link
                class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                to="/"
              >
                <img alt="Gestión APA" class="h-10 w-auto" :src="logoSrc" />
              </router-link>
            </div>
            <div class="w-6/12 flex justify-end">
              <button
                type="button"
                class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                v-on:click="toggleCollapseShow('hidden')"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Navigation -->
        <ul class="md:flex-col md:min-w-full flex flex-col list-none">
          <template v-for="item in modulesByGroup">
            <!-- Group header -->
            <li v-if="item.isGroup" class="items-center" :key="item.id">
              <button
                @click="toggleGroup(item.id)"
                class="text-xs uppercase py-3 font-bold block text-blueGray-400 hover:text-blueGray-600 w-full text-left"
                :style="{ paddingLeft: (item.level * 12) + 'px' }"
              >
                <i
                  class="fas mr-2 text-xs"
                  :class="collapsedGroups[item.id] ? 'fa-caret-right' : 'fa-caret-down'"
                ></i>
                {{ $t(item.name) }}
              </button>
            </li>
            <!-- Module link -->
            <li
              v-else-if="!isGroupCollapsed(item)"
              class="items-center"
              :key="item.path"
            >
              <router-link
                :to="item.path"
                v-slot="{ href, navigate, isActive }"
              >
                <a
                  :href="href"
                  @click="navigate"
                  class="text-xs uppercase py-3 font-bold block"
                  :class="[
                    isActive && item.path != '/'
                      ? 'text-emerald-500 hover:text-emerald-600'
                      : 'text-blueGray-700 hover:text-blueGray-500',
                  ]"
                  :style="{ paddingLeft: (item.level * 12) + 'px' }"
                >
                  <i
                    class="fas mr-2 text-sm"
                    :class="[
                      'fa-' + item.meta.icon,
                      isActive ? 'opacity-75' : 'text-blueGray-300',
                    ]"
                  ></i>
                  {{ $t(item.meta.label) }}
                </a>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import dapLogo from "@/assets/img/dap-logo.png";
import { routes } from "@/routes";
import EmpresaService from "@/services/empresa.service";

export default {
  data() {
    return {
      collapseShow: "hidden",
      dapLogo,
      routes,
      collapsedGroups: {},
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.auth.user,
    }),

    logoSrc() {
      const { idempresa, empresaLogoVersion } = this.userInfo || {};
      if (idempresa && empresaLogoVersion) {
        return EmpresaService.getLogoUrl(idempresa, empresaLogoVersion);
      }
      return this.dapLogo;
    },

    modules() {
      let modules = [];
      const adminRouteGroup = this.routes.find((item) => item.path === "/");
      adminRouteGroup?.children.forEach((child) => {
        if (
          !child.meta.hideOnMenu &&
          (!child.meta.roles ||
            child.meta.roles.some((rol) => this.userInfo?.roles?.includes(rol)))
        ) {
          modules.push(child);
        }
      });
      return modules;
    },
    modulesByGroup() {
      const result = [];
      const groupMap = new Map();
      const groupOrder = []; // Para mantener el orden de aparición

      // Agrupar módulos por sus grupos manteniendo el orden
      this.modules.forEach((module) => {
        const groups = module.meta?.group || [];
        
        if (groups.length === 0) {
          // Módulos sin grupo
          result.push({ ...module, level: 0 });
        } else {
          // Construir el árbol de grupos
          groups.forEach((groupName, index) => {
            const key = groups.slice(0, index + 1).join('::');
            if (!groupMap.has(key)) {
              groupMap.set(key, {
                name: groupName,
                level: index,
                modules: [],
                parentKey: index > 0 ? groups.slice(0, index).join('::') : null,
              });
              groupOrder.push(key); // Guardar orden de aparición
              
              // Colapsar por defecto si no es de primer nivel (level > 0)
              if (index > 0 && !((`group-${key}`) in this.collapsedGroups)) {
                this.collapsedGroups[`group-${key}`] = true;
              }
            }
          });

          // Agregar el módulo al grupo final
          const key = groups.join('::');
          groupMap.get(key).modules.push(module);
        }
      });

      // Construir el árbol en el orden de aparición original
      groupOrder.forEach((key) => {
        const group = groupMap.get(key);
        
        // Agregar encabezado del grupo
        result.push({
          id: `group-${key}`,
          isGroup: true,
          name: group.name,
          level: group.level,
          parentKey: group.parentKey,
        });

        // Agregar módulos del grupo
        group.modules.forEach((module) => {
          result.push({ 
            ...module, 
            level: group.level + 1,
            groupKey: key,
          });
        });
      });

      return result;
    },
  },

  methods: {
    toggleCollapseShow: function (classes) {
      this.collapseShow = classes;
    },

    toggleGroup(groupId) {
      this.collapsedGroups[groupId] = !this.collapsedGroups[groupId];
    },

    isGroupCollapsed(item) {
      if (!item.groupKey) return false;
      
      // Verificar si algún grupo padre está colapsado
      const keys = item.groupKey.split('::');
      for (let i = 1; i <= keys.length; i++) {
        const parentKey = keys.slice(0, i).join('::');
        const groupId = `group-${parentKey}`;
        if (this.collapsedGroups[groupId]) {
          return true;
        }
      }
      return false;
    },
  },
  components: {
    UserDropdown,
  },
};
</script>
